import GemMeterBaseRule from '../GemMeterBaseRule';
import { MISSING_LINK } from '../../../constants/rulesConstants';

export default class MissingButtonLink extends GemMeterBaseRule {
  static ruleId = MISSING_LINK.id;

  static validate(selector: string) {
    const element = GemMeterBaseRule.getElement(selector);
    if (!element) {
      return false;
    }

    if (element.tagName !== 'A') {
      return true;
    }

    const hrefAttr = element.getAttribute('href')!;

    return hrefAttr.length > 1;
  }
}
